// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"c4b6f881","185":"cbecd134","298":"bf2b3074","454":"8d4c2ac1","964":"76e623ba"}[chunkId] + ".chunk.js";
};